import Card from 'components/Card/Card';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import ChevronLeftOutlinedIcon from '@material-ui/icons/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import color from 'config/color';

export const AvatarName = styled(Typography).attrs({
  variant: 'subtitle2'
})`
  && {
    color: ${props => props.theme.palette.primary['500']};
    line-height: 1;
    display: inline;
    margin-right: 8px;
  }
`;

export const CommentCount = styled(Typography).attrs({
  variant: 'body2'
})`
  && {
    text-align: right;
    margin-right: 16px;
  }
`;

export const ForumCard = styled(Card)`
  && {
    padding-bottom: 8px;
  }
`;

export const CategoriesList = styled.div`
  display: flex;
  flex-direction: column;
  height: 50%;
  width: 400px;
  background-color: white;
  border-radius: 10px;
  margin-top: 1.25em;
  overflow: hidden;
  margin-left: 50px;
  @media (max-width: 1200px) {
    width: auto;
    max-width: 49em;
    margin-left: 0;
  }
`;

export const Category = styled.div`
  :hover {
    color: ${props => (props.color ? props.color : 'black')};
    cursor: pointer;
  }
  margin-left: 30px;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 10px;
`;

export const TopicManager = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  margin-left: 13.2%;
  max-width: 49em;
  justify-content: space-between;

  @media (max-width: 600px) {
    margin: 12px;
    width: auto;
  }
`;

export const PaginationButton = styled.button`
  border-radius: 100%;
  border: none;
  margin: 5px;
  padding: 0px 4px;
  color: white;
  cursor: pointer;
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  color: ${color.grey};
  @media (max-width: 600px) {
    display: none;
  }
`;

export const ArrowLeftIcon = styled(ChevronLeftOutlinedIcon)`
  && {
    color: #7777;
  }
`;

export const ArrowRightIcon = styled(ChevronRightOutlinedIcon)`
  && {
    color: #7777;
  }
`;

export const Post = styled.div`
  width: 49em;
  @media (max-width: 960px) {
    width: auto;
  }
`;
